"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialLabels = void 0;
exports.specialLabels = {
    "Item ID": "item ID (Read-Only)",
    "Original ID": "original ID",
    "Type": "type",
    "Read": "read",
    "Color": "color",
    "Flag": "flag",
    "Ratings": "ratings",
    "File": "file",
    "Year": "year",
    "Patent ID": "patent_id",
    "Copyright status": "Copyright status",
};
